import React from "react";

const VARIANTS = {
    draft: "badge badge-draft",
    submitted: "badge badge-submitted",
    computed: "badge badge-submitted",
    approved: "badge badge-approved",
    approved_acct: "badge badge-approved",
    approved_gm: "badge badge-approved",
    rejected: "badge badge-rejected",
    locked: "badge badge-locked",
    posted: "badge badge-approved",
    active: "badge badge-approved",
    open: "badge badge-info",
    closed: "badge badge-locked",
    in_progress: "badge badge-submitted",
    paid: "badge badge-approved",
    resolved: "badge badge-approved",
    cancelled: "badge badge-locked",
    on_leave: "badge badge-info",
    resigned: "badge badge-locked",
    terminated: "badge badge-rejected",
    probationary: "badge badge-draft",
    regular: "badge badge-approved",
    contractor: "badge badge-info",
    project: "badge badge-info",
    daily: "badge badge-info",
    completed: "badge badge-approved",
    available: "badge badge-info",
    assigned: "badge badge-approved",
    retired: "badge badge-locked",
};

export default function StatusBadge({ value }) {
    if (!value) return <span className="badge badge-locked">—</span>;
    const cls = VARIANTS[value] || "badge badge-info";
    return <span className={cls} data-testid={`badge-${value}`}>{String(value).replace(/_/g, " ")}</span>;
}
